import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import maintenance from '../../../assets/images/maintenance.svg'
import {Link} from 'react-router-dom';

const NoPermissionPage = _ => {
    return (
        <>
            <Container>
                <Row className='mt-5 mb-5'>
                    <Col>
                        <div className="text-center mt-5">
                            <img alt='logo' src={maintenance} height="140"/>
                            <h3 className="mt-4">Stay tunned</h3>
                            <p className="mt-4">Ask your system admin to gain access to the site or&nbsp;
                                <Link to='/account/logout'>Logout</Link>
                            </p>
                            <div className="row mt-5">
                                <div className="col-md-4">
                                    <div className="text-center mt-3 pl-1 pr-1">
                                        <i className="dripicons-jewel bg-primary maintenance-icon text-white mb-2"/>
                                        <h5 className="text-uppercase">Why am I see this?</h5>
                                        <p className="text-muted">You do not have the permission to access the system,
                                            so we
                                            cannot let you in at this time.</p>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="text-center mt-3 pl-1 pr-1">
                                        <i className="dripicons-clock bg-primary maintenance-icon text-white mb-2"/>
                                        <h5 className="text-uppercase">When can I access the system?</h5>
                                        <p className="text-muted">As soon as the time your system administrator, you can
                                            have access to the system.</p>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="text-center mt-3 pl-1 pr-1">
                                        <i className="dripicons-question bg-primary maintenance-icon text-white mb-2"/>
                                        <h5 className="text-uppercase">Do you need Support?</h5>
                                        <p className="text-muted">If you need further assistance, please send an email
                                            to
                                            the system administrator email at&nbsp;
                                            <a href="mailto:#"
                                               className="text-muted font-weight-bold">support@akadoc.ai</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <div>
                    <footer className="footer footer-alt">
                        2019 - 2020 © <a href="https://akadoc.ai" className="text-body">akaDoc</a>
                    </footer>
                </div>
            </Container>
        </>
    );
};

export default NoPermissionPage;